/** Namespace for S Design System brand theme. */
const SDS = Symbol.for('SDS');

export { SDS };
//# sourceMappingURL=namespace.js.map
